/* eslint-disable max-len, react/no-danger */
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Resource from "app/core/resource";
import Env from "app/core/environment";

class Description extends React.Component {
    constructor(props) {
        super(props);

        /**
         * @property stringsResource
         * @type {Object}
         */
        this.stringsResource = Resource.getStrings(Env.getInstance().getLanguage());
    }

    /**
     * @private
     * @method _getClasses
     * @returns {Object}
     */
    _getClasses() {
        return classNames({
            "to-basket d-flex align-items-center btn-sm justify-content-center": true,
            "btn-default": true,
            "to-basket--with-price": false,
            "btn-default--outline to-basket--in-basket": false,
            "justify-content-between": false
        }, "btn-block");
    }

    /**
     * @private
     * @method _getTitle
     * @returns {string}
     */
    _getDefaultBtnName() {
        return this.stringsResource.addToBasket.toUpperCase();
    }

    /**
     * @method _getIconName
     * @return {string}
     * @private
     */
    _getIconName() {
        return "icon-cart";
    }

    /**
     * @private
     * @method _getIconClassNames
     * @returns {object}
     */
    _getIconClassNames() {
        return classNames({
            [this._getIconName()]: true,
            "icon--default": true,
            icon: true
        });
    }

    /**
     * @private
     * @method _renderIcon
     * @returns {string}
     */
    _renderIcon() {
        return (
            <span className="buy-icons d-inline-flex align-items-center justify-content-center">
                <span className={this._getIconClassNames()} />
                <span className={classNames("icon icon--hovered", this._getIconName())} />
            </span>
        );
    }

    /**
     * @method render
     * @returns {string}
     */
    render() {
        return (
            <>
                <div className="catalog__description description">
                    {this.props.infoBlock}
                    <div
                        className="description__body"
                        dangerouslySetInnerHTML={{
                            __html: this.props.description
                        }}
                    />
                </div>
                <div className={classNames("buy-block buy-block--xs position-fixed bottom-0 d-md-none base-border-top")} style={{width: '95%'}}>
                    <div className="buy-block__body bg-white" style={{padding: "6px 12px 17px"}}>
                        <button
                            className={this._getClasses()}
                            type="button"
                            title={this._getDefaultBtnName()}
                            // disabled={this._isBuyDisabled()}
                            onClick={this.props.onOpenPricesClick}
                        >
                            <span className="d-flex align-items-center">
                                {this._renderIcon()} {this._getDefaultBtnName()}
                            </span>
                        </button>
                    </div>
                </div>
            </>
        );
    }
}

Description.propTypes = {
    description: PropTypes.string,
    infoBlock: PropTypes.string,
    onOpenPricesClick: PropTypes.func
};

Description.defaultProps = {
    description: "",
    infoBlock: "",
    onOpenPricesClick: () => {}
};

export default Description;
